import(/* webpackMode: "eager" */ "/home/runner/work/practice-tests/practice-tests/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/practice-tests/practice-tests/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/practice-tests/practice-tests/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/practice-tests/practice-tests/public/varsity-tutors-logo.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/practice-tests/practice-tests/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/practice-tests/practice-tests/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"display\":\"swap\",\"subsets\":[\"latin\"],\"variable\":\"--font-poppins\",\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/practice-tests/practice-tests/src/app/TelemetryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/practice-tests/practice-tests/src/components/analytics/TrackedLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/runner/work/practice-tests/practice-tests/src/components/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GamificationProvider"] */ "/home/runner/work/practice-tests/practice-tests/src/components/GamificationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/practice-tests/practice-tests/src/components/navigation/EnhancedSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/practice-tests/practice-tests/src/components/navigation/HamburgerButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/practice-tests/practice-tests/src/components/navigation/MobileNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/practice-tests/practice-tests/src/components/navigation/MobileNavigationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/practice-tests/practice-tests/src/components/navigation/NavItemLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/practice-tests/practice-tests/src/components/navigation/ThemeToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/practice-tests/practice-tests/src/components/navigation/UserProfile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/practice-tests/practice-tests/src/components/SWRProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/practice-tests/practice-tests/src/components/ToastNotifications.tsx");
